export const SHOW_SCT = 'SHOW_SCT';
export const TAKE_HINT = 'TAKE_HINT';
export const SET_HINT_SHOW = 'SET_HINT_SHOWN';
export const SET_RATING_STATUS = 'SET_RATING_STATUS';
export const HIDE_COMPLETION_PANE = 'HIDE_COMPLETION_PANE';
export const TAKE_SOLUTION = 'TAKE_SOLUTION';
export const ADD_ERROR_EXPLANATION_FEEDBACK = 'ADD_ERROR_EXPLANATION_FEEDBACK';